import type { SearchLocationView } from '@zola/svc-marketplace-ts-types';
import { getCookie } from '@zola-helpers/client/dist/es/util/storage';
import type { SearchableVendorTaxonomyKey } from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';
import queryString, { StringifiableRecord } from 'query-string';

export const SEARCHED_LOCATION_KEY = 'zola_marketplace_selected_location';

export type LocationOrAllMarketsType =
  | SearchLocationView
  | {
      type: 'ALL_MARKETS' | 'NO_MARKETS';
      label: string;
      slug: string;
      stateSlug?: undefined;
      marketSlug?: undefined;
      usCityId?: undefined;
      storefrontSearchPayload?: undefined;
      geoCoordinates?: undefined;
    };

export const deafultAllMarkets = {
  type: 'ALL_MARKETS',
  label: 'All locations',
  slug: 'all-locations',
} as LocationOrAllMarketsType;

export const getSearchedLocation = () => {
  const recordedLocation = getCookie(SEARCHED_LOCATION_KEY);
  if (recordedLocation) {
    return JSON.parse(recordedLocation) as LocationOrAllMarketsType;
  }
  // default to all
  return deafultAllMarkets;
};

/**
 * Generates a URL to search for vendors
 *
 * @param {*} vendorTaxonomyKey - Which vendor is searched
 * @param {*} selectedLocationSlug - Where is the search, this is more important for SEO so it comes first in the generated url
 * @param {*} otherSlugs - Any additional slugs, separated by -- to include. Use for filters.
 * @param {*} queryString - Query string to include in the URL.  Used for filters like price or availability.
 *
 * @returns URL to a vendor search page
 */
export const vendorSearchUrl = (
  vendorTaxonomyKey: SearchableVendorTaxonomyKey | null = null,
  selectedLocationSlug: string | null = null,
  otherSlugs: string[] = [],
  query?: StringifiableRecord
): string => {
  const parts = [selectedLocationSlug, vendorTaxonomyKey, ...otherSlugs];
  // The all-locations is historical and can probably be removed
  const slugs = parts.filter((part) => !!part && part !== 'all-locations').join('--');

  const paths = ['wedding-vendors', 'search', slugs].filter((part) => !!part);
  const url = `/${paths.join('/')}`;

  return queryString.stringifyUrl({ url, query });
};

export default vendorSearchUrl;
